<div class="filter-group" data-group-visibility-id="showCurrencyGeneralSettings">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showCurrencyGeneralSettings" (click)="filter.groupVisibility.showCurrencyGeneralSettings = !filter.groupVisibility.showCurrencyGeneralSettings; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="General">
          Configure the economy and how currency is divided into tiers.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showCurrencyGeneralSettings) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showCurrencyGeneralSettings">
      <div class="filter filter-property filter-padded-left" style="width: 100%;">
        <span class="filter-body">
          <span filter-title text="Economy">
            Select the Game Mode (League, Hardcore League, Standard, Hardcore Standard) you play in, which determines the values of Currency and Uniques. Use '<strong>Fixed (SSF)</strong>' if you do not want to follow any economy.
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.ssf" (click)="toggleSsf()"></button>
            </span>
            <span class="table-checkbox-label">SSF</span>
          </div>
          <span class="sep"></span>
          <app-select [class.include-comparator]="false" [(ngModel)]="filter.economy" (selectedValueChange)="updateEconomy()">
            <app-option [value]="Economy.League" [text]="'League'"></app-option>
            <app-option [value]="Economy.LeagueHardcore" [text]="'HC League'"></app-option>
            <app-option [value]="Economy.Standard" [text]="'Standard'"></app-option>
            <app-option [value]="Economy.StandardHardcore" [text]="'HC Standard'"></app-option>
            <app-option [value]="Economy.Fixed" [text]="'Fixed (SSF)'"></app-option>
          </app-select>
        </span>
      </div>

      <div class="filter filter-property filter-padded-left" style="width: 100%;">
        <span class="filter-body">
          <span filter-title text="Currency Tiering Mode">
            This determines how Currency is divided into tiers, by changing the cutoff values for each of the tiers. Define your own Tiering Mode or review and customize which currency is in which tier on the <a href="/tier-list/currency">Currency Tier List</a> tab.
          </span>
          <span class="sep"></span>
          <app-select [class.include-comparator]="false" [(ngModel)]="filter.tieringMode" (selectedValueChange)="currencyTieringModeChanged($event)">
            <app-option [value]="'Early'" [text]="'Early-game'"></app-option>
            <app-option [value]="'Normal'" [text]="'Normal'"></app-option>
            <app-option [value]="'Strict'" [text]="'Strict'"></app-option>
            <app-option [value]="'VeryStrict'" [text]="'Very Strict'"></app-option>
            <app-option [value]="'Custom'" [text]="'Custom'"></app-option>
          </app-select>
          @if (filter.tieringMode === 'Custom') {
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button" (click)="openCustomTieringDialog()">
              <span class="icon icon-equalizer"></span>
            </button>
          }
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>

@if (showCustomTieringDialog) {
  <app-custom-currency-tiering-mode-dialog
    [filter]="filter"
    (close)="closeCustomTieringDialog()">
  </app-custom-currency-tiering-mode-dialog>
}
